<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?'新增一级分类':'修改一级分类'}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cname')" prop="cat_cname">
                        <el-input v-model="formData.cat_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('sort')" prop="sort_id">
                        <el-input v-model="formData.sort_id" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
<!--            <el-row>-->
<!--                <el-col :span="12">-->
<!--                    <el-form-item :label="$t('status')" prop="cat_status" v-if="op == 'upd'">-->
<!--                        <el-radio-group v-model="formData.cat_status">-->
<!--                            <el-radio v-for="item in cat_statuss" :key="item.key" :label="item.key">{{item.value}}</el-radio>-->
<!--                        </el-radio-group>-->
<!--                    </el-form-item>-->
<!--                </el-col>-->
<!--            </el-row>-->
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <span class="f-red" v-if="op == 'add'">（提示：添加新分类需程序接入）</span>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        data:function(){
            return{
                op: this.$base.getRequest().op,
                cat_statuss:[],
                formData: {
                    cat_id:'',
                    sort_id:99,
                    cat_cname: '',
                    cat_status:'1' //默认为1
                },
                rule: {
                    sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    cat_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cat_status: [{required: true, message: this.$t('input'), trigger: 'change'}],
                }
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.cat_id = this.$base.getRequest().id;
            if(this.op == 'upd'){
                this.getInfo();
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                var id = this.formData.cat_id;
                if(!id){
                    return;
                }
                var data = {
                    cat_id: id
                };
                this.$base.showLoading();
                this.$request.sendPost("base-goodscat/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.cat_statuss = this.cat_statuss.concat(data.cat_status)
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op=='upd'?"base-goodscat/upd":"base-goodscat/add";
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/base/goodscat/save.vue